import Common from "./Common";

export default props => {
  return <>
    <Common {...props} type="day"/>
  </>;
};